(() => {
  const initialize = (section) => {
    if (section.dataset.phScrollReady === 'true') return;

    const track = section.querySelector('[data-ph-featured-scroll-track]');
    const previous = section.querySelector('[data-ph-featured-previous]');
    const next = section.querySelector('[data-ph-featured-next]');
    if (!track) return;

    section.dataset.phScrollReady = 'true';
    let dragging = false;
    let startX = 0;
    let startScrollLeft = 0;
    let dragDistance = 0;
    let animationFrame = 0;
    let pendingScrollLeft = 0;
    let pointerId = null;
    let pointerPressed = false;

    const updateButtons = () => {
      const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
      if (previous) previous.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= maxScroll - 2;
    };

    const move = (direction) => {
      track.scrollBy({
        left: direction * track.clientWidth * .92,
        behavior: 'smooth'
      });
    };

    previous?.addEventListener('click', () => move(-1));
    next?.addEventListener('click', () => move(1));

    track.addEventListener('pointerdown', (event) => {
      // Touch devices use the browser's native momentum scrolling. Handling
      // touch here as well makes the track fight the browser and snap back.
      if (event.pointerType !== 'mouse' || event.button !== 0) return;
      pointerPressed = true;
      pointerId = event.pointerId;
      dragging = false;
      startX = event.clientX;
      startScrollLeft = track.scrollLeft;
      dragDistance = 0;
    });

    track.addEventListener('pointermove', (event) => {
      if (!pointerPressed || event.pointerId !== pointerId) return;
      dragDistance = event.clientX - startX;
      if (!dragging && Math.abs(dragDistance) < 5) return;
      if (!dragging) {
        dragging = true;
        track.classList.add('is-dragging');
        track.setPointerCapture(event.pointerId);
      }
      pendingScrollLeft = startScrollLeft - dragDistance;
      if (!animationFrame) {
        animationFrame = requestAnimationFrame(() => {
          track.scrollLeft = pendingScrollLeft;
          animationFrame = 0;
        });
      }
      event.preventDefault();
    });

    const endDrag = (event) => {
      if (!pointerPressed || (event.pointerId != null && event.pointerId !== pointerId)) return;
      pointerPressed = false;
      pointerId = null;
      if (!dragging) return;
      dragging = false;
      if (animationFrame) {
        cancelAnimationFrame(animationFrame);
        animationFrame = 0;
        track.scrollLeft = pendingScrollLeft;
      }
      track.classList.remove('is-dragging');
      if (track.hasPointerCapture(event.pointerId)) track.releasePointerCapture(event.pointerId);
      updateButtons();
    };

    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);
    track.addEventListener('scroll', updateButtons, { passive: true });
    track.addEventListener('click', (event) => {
      if (Math.abs(dragDistance) > 8) {
        event.preventDefault();
        event.stopPropagation();
        dragDistance = 0;
      }
    }, true);
    window.addEventListener('resize', updateButtons, { passive: true });

    updateButtons();
  };

  const initializeAll = (scope = document) => {
    scope.querySelectorAll('[data-ph-featured-scroll]').forEach(initialize);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll());
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
